export interface IDcRule {
    list: IDcRuleItem[];
    hasActiveRule: boolean;
    activeRule?: IDcRuleActive;
}

export interface IDcRuleItem {
    dateChange?: string[];
    dateEnd?: string;
    dateStart?: string;
    id: number;
    isActive: boolean;
    name: string;
}

export enum EDcActiveRuleType {
    callCharges = 'CALL_CHARGES',
    otherCharges = 'OTHER_CHARGES',
    productCharges = 'PRODUCT_CHARGES',
}

export interface IDcRuleActiveItem {
    child: IDcRuleActiveItem[];
    limit: {
        break?: number;
        measure?: string;
        warn?: number;
    };
    name: string;
    type?: EDcActiveRuleType;
}

export interface IDcRuleActive {
    id: number;

    rules: IDcRuleActiveItem[];

    // Оповещение абонентов
    notification: {
        notifyOverBreak: boolean;
        notifyOverWarning: boolean;
        notifySetOrChangeLimits: boolean;
        notifyStartUseLimits: boolean;
    };

    // Расписание действия
    scheduleList: Array<{
        day: number; // Можно начинать с 0?
        time?: {
            start: string; // HH:MM:SS
            end: string; // HH:MM:SS
        };
    }>;
}
